import { Role } from '@wix/ambassador-genie-chat-service-v1-no-entity/types';
export const mapMessagesFromServiceToClient = messages => (messages ?? []).map(mapMessage).filter(message => Boolean(message.content));
export const mapMessage = message => ({
  id: message.id ?? '',
  content: message.content ?? '',
  role: message.role === Role.USER ? 'user' : 'assistant',
  createdDate: message.createdDate ?? undefined,
  attachments: (message.attachments ?? []).map(attachment => ({
    fileName: attachment.fileName ?? '',
    url: attachment.url ?? '',
    mimeType: attachment.mimeType ?? '',
    textFileContent: attachment.textFileContent ?? '',
    viewUrl: attachment.viewUrl ?? ''
  })),
  references: (message.references ?? []).map(reference => ({
    id: reference.id ?? '',
    label: reference.label ?? '',
    data: reference.data ?? '',
    wholeMessagePreview: reference.wholeMessagePreview ? {
      alt: reference.wholeMessagePreview.alt ?? ''
    } : undefined,
    replyToMessage: reference.replyToMessage ? {
      content: reference.replyToMessage.content ?? ''
    } : undefined
  }))
});
//# sourceMappingURL=convertMessages.js.map